export const aboutData = {
  brandName: "风车动漫",
  brandIntro:
    "风车动漫成立于2020年，致力于为广大动漫爱好者打造一个高质量、内容丰富的在线动漫观看平台。我们的动漫库涵盖数千部作品，从经典老番到最新热播，从热血战斗到治愈日常，应有尽有。",
  mission:
    "我们的使命是让每一位动漫爱好者都能轻松找到自己喜爱的作品，享受极致的追番体验。无论你是资深老宅还是刚入坑的新人，风车动漫都有属于你的精彩内容。",
  vision:
    "成为中国最受欢迎的动漫社区平台，让动漫文化在更多人心中生根发芽。我们希望通过优质内容和良好体验，连接每一位热爱二次元文化的伙伴。",
  values: [
    {
      title: "内容丰富",
      description: "数千部动漫作品，覆盖全类型全年代，持续更新中。无论你喜欢什么风格，都能在这里找到心仪的作品。",
      icon: "ri-stack-line",
    },
    {
      title: "品质至上",
      description: "高清画质、流畅播放、精准字幕，我们追求每一个细节的完美呈现。",
      icon: "ri-vip-diamond-line",
    },
    {
      title: "用户体验",
      description: "简洁直观的界面设计，智能推荐系统，让找番追番变得前所未有的轻松。",
      icon: "ri-user-heart-line",
    },
    {
      title: "社区共建",
      description: "鼓励用户互动交流，弹幕评论共同打造活跃的动漫社区氛围。",
      icon: "ri-group-line",
    },
  ],
  stats: [
    { label: "动漫作品", value: "5000+" },
    { label: "活跃用户", value: "300万+" },
    { label: "覆盖类型", value: "30+" },
    { label: "成立年份", value: "2020" },
  ],
  reputation: [
    {
      content:
        "风车动漫是我用过最好用的动漫网站，资源超全，更新速度也快。界面简洁干净，没有乱七八糟的广告，看番体验一级棒！",
      author: "资深动漫迷 - 小明",
      avatar: "https://readdy.ai/api/search-image?query=Anime%20style%20portrait%20of%20young%20Chinese%20boy%20with%20glasses%2C%20friendly%20smile%2C%20simple%20background%2C%20clean%20anime%20art%20style&width=80&height=80&seq=avatar-01&orientation=squarish",
      rating: 5,
    },
    {
      content:
        "作为一个看了十几年动漫的老宅，风车动漫的分类做得真的很好。不管是找经典老番还是追最新热播，都能很快找到。强烈推荐！",
      author: "十年老宅 - 阿强",
      avatar: "https://readdy.ai/api/search-image?query=Anime%20style%20portrait%20of%20Chinese%20man%20in%20his%20twenties%20with%20cool%20haircut%2C%20confident%20expression%2C%20simple%20background%2C%20clean%20anime%20art%20style&width=80&height=80&seq=avatar-02&orientation=squarish",
      rating: 5,
    },
    {
      content:
        "画质清晰流畅，字幕翻译也很到位。最重要的是更新真的很快，每周新番都能第一时间看到。已经推荐给身边所有追番的朋友了！",
      author: "追番达人 - 小红",
      avatar: "https://readdy.ai/api/search-image?query=Anime%20style%20portrait%20of%20young%20Chinese%20girl%20with%20long%20hair%2C%20sweet%20smile%2C%20simple%20background%2C%20clean%20anime%20art%20style&width=80&height=80&seq=avatar-03&orientation=squarish",
      rating: 5,
    },
  ],
  contact: {
    email: "contact@fengchedongman.com",
    qq: "1234567890",
    wechat: "风车动漫官方",
    address: "上海市浦东新区张江高科技园区动漫产业基地",
    phone: "400-888-6666",
  },
  milestones: [
    { year: "2020", event: "风车动漫正式上线，初始收录500+部动漫作品" },
    { year: "2021", event: "用户突破50万，新增高清播放功能" },
    { year: "2022", event: "动漫库扩充至3000+部，推出智能推荐系统" },
    { year: "2023", event: "用户突破200万，上线社区功能" },
    { year: "2024", event: "全面升级播放体验，动漫库突破5000部" },
  ],
};